<app-spu-form-wrapper
  data-testid="package-spu-edit-form-wrapper"
  [config]="config"
  [editMode]="true"
  [viewMode]="false"
  [showFaq]="true"
></app-spu-form-wrapper>
